import React, { useState, useEffect } from "react"
import PostTemplate from "../../components/cision/post"
import { format } from "date-fns"

export default function PostPage({ location, pageContext }) {
  const [post, setPost] = useState(pageContext.release || null)

  useEffect(() => {
    async function fetchAndSetPost() {
      if (location && location.state && location.state.post) {
        const post = {
          ...location.state.post,
        }
        if (post && post.PublishDate) {
          const date = new Date(post.PublishDate)
          let formattedDate = post.PublishDate
          if (!isNaN(date)) {
            try {
              formattedDate = format(date, "yyyy-MM-dd HH:mm")
            } catch (e) {
              formattedDate = ""
            }
          }
          post.PublishDate = formattedDate
        }

        setPost(post)
      } else if (!post) {
        window.location = "/newsroom/"
      }
    }
    fetchAndSetPost()
  }, [location])

  return post ? <PostTemplate apiPost={post} /> : null
}
